var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMastercard2019Logo1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 28,
    viewBox: "0 0 43 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3133 2.99445H15.6867V25.0056H27.3133V2.99445Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4249 14.0001C16.4249 9.5279 18.418 5.56124 21.4815 2.99457C19.23 1.1279 16.388 0.00012207 13.2876 0.00012207C5.94249 0.00012207 0 6.26123 0 14.0001C0 21.739 5.94249 28.0001 13.2876 28.0001C16.388 28.0001 19.23 26.8724 21.4815 25.0057C18.418 22.4779 16.4249 18.4723 16.4249 14.0001Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 14C43 21.7389 37.0575 28 29.7124 28C26.612 28 23.7699 26.8722 21.5184 25.0056C24.6189 22.4389 26.5751 18.4722 26.5751 14C26.5751 9.52778 24.582 5.56112 21.5184 2.99445C23.7699 1.12779 26.612 3.8147e-06 29.7124 3.8147e-06C37.0575 3.8147e-06 43 6.3 43 14Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 28,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMastercard2019Logo1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Mastercard_2019_logo 1.f27e2754.svg";
export { ForwardRef as ReactComponent };